import { useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, Loader2, ChevronLeft } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { CONSENT_TEXT } from "@/config";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";

export const ModuleContactGate = ({ moduleTitle, onDone }) => {
  const [f, setF] = useState({ prenom: "", telephone: "", courriel: "", consent: false });
  const [sending, setSending] = useState(false);

  const submit = async () => {
    if (!f.prenom.trim()) return toast.error("Votre prénom est requis.");
    if (!f.telephone.trim()) return toast.error("Votre téléphone est requis.");
    if (!f.courriel.trim()) return toast.error("Votre courriel est requis.");
    if (f.telephone.replace(/\D/g, "").length < 10) return toast.error("Numéro de téléphone invalide (au moins 10 chiffres).");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.courriel.trim())) return toast.error("Adresse courriel invalide.");
    if (!f.consent) return toast.error("Le consentement est requis (Loi 25).");
    setSending(true);
    try {
      await api.createLead({ prenom: f.prenom, telephone: f.telephone, courriel: f.courriel, consentement: true, consentement_texte: CONSENT_TEXT, profil: `Formation : ${moduleTitle}`, source: `Formation : ${moduleTitle}` });
      localStorage.setItem("mpp_contact_done", "1");
      toast.success("Merci ! Bonne consultation.");
      onDone();
    } catch {
      toast.error("Une erreur est survenue. Réessayez.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="module-contact-gate" className="min-h-screen bg-[#FDFDFD] flex flex-col">
      <div className="max-w-5xl w-full mx-auto px-4 sm:px-8 py-4">
        <Link to="/formations" data-testid="gate-back-btn" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-600 hover:text-[#012141]"><ChevronLeft size={18} /> Formations</Link>
      </div>
      <div className="flex-1 grid place-items-center px-4 pb-16">
        <div className="w-full max-w-md">
          <span className="grid place-items-center w-16 h-16 rounded-3xl bg-[#012141] text-[#F5C64E] shadow-lg mx-auto"><Sparkles size={30} /></span>
          <h1 className="mt-6 text-2xl sm:text-3xl font-bold text-[#012141] font-heading text-center leading-tight">Personnalisons votre accès</h1>
          <p className="mt-2 text-base text-slate-500 text-center">Pour ouvrir « {moduleTitle} », dites-nous à qui l'adresser — on garde le fil avec vous.</p>
          <div className="mt-8 rounded-2xl border border-[#012141]/15 bg-white p-6 shadow-sm space-y-3">
            <div>
              <label className="text-sm font-semibold text-[#012141]">Comment doit-on vous appeler ?</label>
              <Input data-testid="gate-prenom" placeholder="Votre prénom" value={f.prenom} onChange={(e) => setF({ ...f, prenom: e.target.value })} className="mt-1.5 rounded-xl" />
            </div>
            <div>
              <label className="text-sm font-semibold text-[#012141]">Votre numéro de téléphone</label>
              <Input data-testid="gate-telephone" type="tel" placeholder="Votre téléphone" value={f.telephone} onChange={(e) => setF({ ...f, telephone: e.target.value })} className="mt-1.5 rounded-xl" />
            </div>
            <div>
              <label className="text-sm font-semibold text-[#012141]">Votre courriel</label>
              <Input data-testid="gate-courriel" type="email" placeholder="Votre courriel" value={f.courriel} onChange={(e) => setF({ ...f, courriel: e.target.value })} className="mt-1.5 rounded-xl" />
            </div>
            <label className="flex items-start gap-3 cursor-pointer pt-1">
              <Checkbox data-testid="gate-consent" checked={f.consent} onCheckedChange={(v) => setF({ ...f, consent: !!v })} className="mt-0.5" />
              <span className="text-xs text-slate-500 leading-relaxed">{CONSENT_TEXT}</span>
            </label>
          </div>
          <button data-testid="gate-submit-btn" onClick={submit} disabled={sending} className="mt-5 w-full inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-[#012141] text-white font-semibold shadow-lg hover:bg-[#00172E] disabled:opacity-40 transition-all">
            {sending ? <><Loader2 className="animate-spin" size={18} /> Un instant…</> : <><Sparkles size={16} /> Accéder à la formation</>}
          </button>
        </div>
      </div>
    </div>
  );
};
